import { useState, useRef, useEffect, useCallback } from "react";
import { NavLink, useNavigate, Link, useLocation } from "react-router-dom";
import '../styles/navBar.css'
import { coloresPorLetra } from "../static/colors.js"
import Modal from "../components/Modal";
import Notificaciones from "../components/Notificaciones";
import SocialMedia from "../components/SocialMedia/SocialMedia";
import { Form } from 'react-bootstrap';
import { http } from "../auth.js";

/*-----Iconos-----*/
import { FaBars, FaUserAlt } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { ImCogs } from "react-icons/im";
import { FaRightFromBracket } from "react-icons/fa6";
import { getFullUrl } from "../utils/config.js";
import { useThemeManager} from "../Hooks/ThemeManager.jsx";

const ThemeToggle = ({ theme, toggleTheme }) => {
  const { themeColors } = useThemeManager();
  
  return (
    <button
      className={`theme-toggle ${theme === 'dark' ? 'theme-toggle--toggled' : ''}`}
      type="button"
      onClick={toggleTheme}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        width="1em"
        height="1em"
        fill="currentColor"
        className="theme-toggle__expand"
        viewBox="0 0 32 32"
      >
        <clipPath id="theme-toggle__expand__cutout">
          <path d="M0-11h25a1 1 0 0017 13v30H0Z" />
        </clipPath>
        <g clipPath="url(#theme-toggle__expand__cutout)">
          <circle cx="16" cy="16" r="8.4" />
          <path d="M18.3 3.2c0 1.3-1 2.3-2.3 2.3s-2.3-1-2.3-2.3S14.7.9 16 .9s2.3 1 2.3 2.3zm-4.6 25.6c0-1.3 1-2.3 2.3-2.3s2.3 1 2.3 2.3-1 2.3-2.3 2.3-2.3-1-2.3-2.3zm15.1-10.5c-1.3 0-2.3-1-2.3-2.3s1-2.3 2.3-2.3 2.3 1 2.3 2.3-1 2.3-2.3 2.3zM3.2 13.7c1.3 0 2.3 1 2.3 2.3s-1 2.3-2.3 2.3S.9 17.3.9 16s1-2.3 2.3-2.3zm5.8-7C9 7.9 7.9 9 6.7 9S4.4 8 4.4 6.7s1-2.3 2.3-2.3S9 5.4 9 6.7zm16.3 21c-1.3 0-2.3-1-2.3-2.3s1-2.3 2.3-2.3 2.3 1 2.3 2.3-1 2.3-2.3 2.3zm2.4-21c0 1.3-1 2.3-2.3 2.3S23 7.9 23 6.7s1-2.3 2.3-2.3 2.4 1 2.4 2.3zM6.7 23C8 23 9 24 9 25.3s-1 2.3-2.3 2.3-2.3-1-2.3-2.3 1-2.3 2.3-2.3z" />
        </g>
      </svg>
    </button>
  );
};

const ToggleBottom = () => {
  const { themeMode, toggleThemeMode } = useThemeManager();
  const { themeColors } = useThemeManager();

  return (
    <div className="modoOscuro" onClick={toggleThemeMode}>
      <div className="contenToggle color-secondary">
        <div className="toggleTheme">
          <ThemeToggle theme={themeMode} toggleTheme={toggleThemeMode} />
        </div>
        {themeMode === "dark" ? "Modo Oscuro" : "Modo Claro"}
      </div>

      <Form.Check
        type="switch"
        id="custom-switch"
        checked={themeMode === "dark"}
        onChange={toggleThemeMode}
      />
    </div>
  );
};

const NavBar = ({ children }) => {
  const { themeMode } = useThemeManager();
  const { themeColors } = useThemeManager();
  const location = useLocation();
  const [showNavbar, setShowNavbar] = useState(false);
  const navRef = useRef(null);
  const btnRef = useRef(null);
  const [showUserSesion, setShowUserSesion] = useState(false);
  const [isOpen, setIsOpen] = useState(null);
  const navigate = useNavigate();
  let userName = localStorage.getItem("userName");
  const token = localStorage.getItem("token");
  const [pendientes, setPendientes] = useState(0);
  const [notificaciones, setNotificaciones] = useState([]);
  const [loadingNotif, setLoadingNotif] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [notifPage, setNotifPage] = useState(1);

  const fetchNotificacionesPreview = useCallback(() => {
    http
      .get("/clientes/notificaciones?preview=true", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => setPendientes(response.data))
      .catch((error) => console.error("Error al obtener notificaciones pendientes:", error));
  }, [token]);

  const fetchNotificaciones = (pageNum) => {
    setLoadingNotif(true);
    http
      .get(`/clientes/notificaciones?preview=false&page=${pageNum}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setNotificaciones((prev) =>
          pageNum === 1 ? response.data.data : [...prev, ...response.data.data]
        );
        
        setPendientes(0);
        setHasMore(response.data.has_next);
        setNotifPage(pageNum);
        setLoadingNotif(false);
      })
      .catch((error) => {
        console.error("Error al obtener notificaciones:", error);
        setLoadingNotif(false);
      });
  };

  const handleNotificacionesOpen = () => {
    setHasMore(false);
    setNotifPage(1);
    fetchNotificaciones(1);
  };

  const handleNotificacionesLoadMore = () => {
    if (hasMore && !loadingNotif) {
      fetchNotificaciones(notifPage + 1);
    }
  };
  const [logoUrl, setLogoUrl] = useState("");

  useEffect(() => {
    const url = getFullUrl("image/logo_app_blanco");
    const url2 = getFullUrl("image/logo_out");
    setLogoUrl(themeMode === "dark" ? url : url);
  }, [themeMode]);

  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar);
  };

  const handleShowUserSesion = () => {
    setShowUserSesion(!showUserSesion);
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('selectedServ');
    localStorage.removeItem('ID');
    navigate('/');
  };

  const getColorByInitialFont = (initial) => {
    if (!initial || initial.length < 1) {
      return "#505050";
    }
    const upperInitial = initial.toUpperCase().charAt(0);
    const color = coloresPorLetra[upperInitial] || "#cccccc";

    const luminance = (0.299 * parseInt(color.substr(1, 2), 16) +
      0.587 * parseInt(color.substr(3, 2), 16) +
      0.114 * parseInt(color.substr(5, 2), 16)) / 255;

    return luminance > 0.45 ? "#000000" : "#ffffff";
  };

  const handleClickOutside = (event) => {
    if (navRef.current &&
      !navRef.current.contains(event.target) && 
      btnRef.current &&
      !btnRef.current.contains(event.target)
    ) {
      setShowNavbar(false);
    }
  };
  
  useEffect(() => {
    fetchNotificacionesPreview();
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [fetchNotificacionesPreview]);

  useEffect(() => {
    if (isOpen) {
      handleClose();
    }
  }, [location]);

  return (
    <>
      <Modal
        id={"modalS"}
        titulo={<div className="perfil color-secondary" style={{ backgroundColor: "var(--fondoBlanco)" }}>
          <FaUserAlt className="iconUser" />
          <span>Perfil de usuario</span>
        </div>}
        onClose={handleClose}
        isOpen={isOpen}
      >
        <div className="bodyUsuarioSesion color-secondary">
          <div className="usuario cursorNone" style={{ backgroundColor: coloresPorLetra[userName?.charAt(0).toUpperCase()], color: getColorByInitialFont(userName?.charAt(0).toUpperCase()) }}>
            {userName?.charAt(0).toUpperCase()}
          </div>
          <span className="userName">{userName}</span>
          {!showNavbar && <ToggleBottom />}
          <div className="operaciones">
            <Link to="/perfil" className="operacion1 color-secondary">
              <span>Gestionar perfil</span>
              <ImCogs className="iconConfig" />
            </Link>
            <div className="operacion2" onClick={handleLogout}>
              <span>Cerrar sesión</span>
              <FaRightFromBracket />
            </div>
          </div>
        </div>
      </Modal>
      <div className="contenedorLayout">
        <div className="float">
          <Notificaciones
            pendientes={pendientes}
            notificaciones={notificaciones}
            loading={loadingNotif}
            hasMore={hasMore}
            onOpen={handleNotificacionesOpen}
            onLoadMore={handleNotificacionesLoadMore}
          />
        </div>
        <div className="barra">
          <div className="containerBarra">
            <div className="logo_link">
              <div className="logo">
                <img src={logoUrl} alt="360NET" onClick={() => navigate('/home')} />
              </div>
              <div ref={navRef} className={`nav-elements  ${showNavbar ? "active" : ""}`}>
                <div className="miPerfil" onClick={() => navigate('/perfil')}>
                  <div className="usuario cursorNone" style={{ backgroundColor: coloresPorLetra[userName?.charAt(0).toUpperCase()], color: getColorByInitialFont(userName?.charAt(0).toUpperCase()) }}>
                    {userName?.charAt(0).toUpperCase()}
                  </div>
                  <span>Mi perfil</span>
                </div>
                {showNavbar && <ToggleBottom />}
                <div className="cerrarSesion" onClick={handleLogout}>
                  <FaRightFromBracket />
                  Cerrar Sesión
                </div>
                <ul>
                  <li>
                    <NavLink to="/home">Inicio</NavLink>
                  </li>
                  <li>
                    <NavLink to="/pago">Pago</NavLink>
                  </li>
                  <li>
                    <NavLink to="/facturas">Mis Facturas</NavLink>
                  </li>
                  <li>
                    <NavLink to="/contactos">Contáctanos</NavLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className="iconos">
              <SocialMedia />
              <Notificaciones
                pendientes={pendientes}
                notificaciones={notificaciones}
                loading={loadingNotif}
                onOpen={handleNotificacionesOpen}
              />
              <div className="usuario" onClick={handleOpen} style={{ backgroundColor: coloresPorLetra[userName?.charAt(0).toUpperCase()], color: getColorByInitialFont(userName?.charAt(0).toUpperCase()) }}>
                {userName?.charAt(0).toUpperCase()}
              </div>
              <div className="menu-icon" onClick={handleShowNavbar} ref={btnRef}>
                <FaBars />
              </div>
            </div>
          </div>
        </div>
        <div className="contenidoGeneral">
          {children}
        </div>
      </div>
    </>
  );
};

export default NavBar;